export const OPEN_NOTIFICATION_MENU = "OPEN_NOTIFICATION_MENU"
export const CLOSE_NOTIFICATION_MENU = "CLOSE_NOTIFICATION_MENU"
export const FETCHING_NOTIFICATION = "FETCH_NOTIFICATION"
export const FETCHED_NOTIFICATION = "FETCHED_NOTIFICATION"
export const FAILED_FETCH_NOTIFICATION = "FAILED_FETCH_NOTIFICATION"
export const NOTIFICATION_NEW_INDICATOR = "NOTIFICATION_NEW_INDICATOR"